import { getPage } from '@/lib/get-page'
import { Suspense } from 'react'
import { ImageFieldProps, LinkProps } from '@/types/types'
import PromoBlock from '../promo-block/PromoBlock'

type FeaturedPostProps = {
  postId: number
  customLinkText?: string
}

export default function FeaturedPost({ postId, customLinkText = 'Read more' }: FeaturedPostProps) {
  if (!postId) {
    return null
  }

  return (
    <Suspense fallback={<PromoBlock isLoading={true} />}>
      <FeaturedPostContent postId={postId} customLinkText={customLinkText} />
    </Suspense>
  )
}

async function FeaturedPostContent({ postId, customLinkText = 'Read more' }: FeaturedPostProps) {
  const featuredPost = postId ? await getPage(postId) : null

  if (!featuredPost?.id) {
    return null
  }

  const {
    acf: { featured_image: image, featured_summary: text } = {},
    title: { rendered: title },
    type: postType,
    post_type_label: postTypeLabel,
    link: permalink,
  } = featuredPost

  const heading = ['all-news', 'all-work', 'all-events'].includes(postType) ? postTypeLabel : null

  const link: LinkProps = {
    url: permalink,
    title: customLinkText || null,
  }

  return <PromoBlock image={image} heading={heading} title={title} text={text} link={link} />
}
